module.exports = __webpack_public_path__ + "img/wallet_02_evm_3.2b9683db.png";